import { B2bPlanCategoryEsPerecoiValues } from '@Common/types/b2b/plans';
import type { EmployeeStatus } from '@Common/types/bo/b2b/employees_properties';

import { parseAllocations } from '@sh4res/bo-common/resources/b2b/withdrawals/common';

const perecoCategories = new Set<string>(B2bPlanCategoryEsPerecoiValues);

type WithdrawalPlan = {
  plan_id: string;
  category: string;
};

// Available PERECO only exists after an approved retirement withdrawal.
// The API checks that withdrawal again before accepting an empty document list.
export function skipsWithdrawalIdentityDocuments({
  from,
  employeeStatus,
  allocations,
  plans,
}: {
  from: unknown;
  employeeStatus: EmployeeStatus | null | undefined;
  allocations: unknown;
  plans: readonly WithdrawalPlan[] | null | undefined;
}) {
  if (
    from !== 'available' ||
    employeeStatus !== 'retired' ||
    plans === undefined ||
    plans === null ||
    plans.length === 0
  ) {
    return false;
  }

  const availableAllocations =
    typeof allocations === 'object' && allocations !== null && 'available' in allocations
      ? (allocations as { available?: Record<`${number}-${string}`, number | null> }).available
      : undefined;
  const selected = parseAllocations(availableAllocations ?? {}, 'withdrawable');
  if (selected.length === 0) {
    return false;
  }

  const categoryByPlanId = new Map(plans.map((plan) => [plan.plan_id, plan.category]));

  return selected.every((allocation) =>
    perecoCategories.has(categoryByPlanId.get(allocation.saving_plan_id) ?? ''),
  );
}
